import React from 'react';
import { Select, SelectItem } from '@carbon/react';

export type SortOrder = 'newest' | 'oldest' | 'title_ascending' | 'title_descending';

interface SortDropdownProps {
  sortOrder: SortOrder;
  onChange: (newOrder: SortOrder) => void;
  labelText?: string;
  options?: { value: SortOrder; text: string }[];
  className?: string;
}

const SortDropdown: React.FC<SortDropdownProps> = ({
  sortOrder,
  onChange,
  labelText = 'Sort by',
  options,
  className,
}) => {
  const defaultOptions: { value: SortOrder; text: string }[] = [
    { value: 'newest', text: 'Newest to Oldest' },
    { value: 'oldest', text: 'Oldest to Newest' },
    { value: 'title_ascending', text: 'Title A–Z' },
    { value: 'title_descending', text: 'Title Z–A' },
  ];

  const opts = options || defaultOptions;

  return (
    <div className={className ?? 'sort-container'} data-testid="sort-dropdown-wrapper">
      <Select
        id="sort-dropdown"
        value={sortOrder}
        onChange={e => onChange(e.target.value as SortOrder)}
        labelText={labelText}
      >
        {opts.map(opt => (
          <SelectItem key={opt.value} value={opt.value} text={opt.text} />
        ))}
      </Select>
    </div>
  );
};

export default SortDropdown;
